import React from 'react';
import PropTypes from 'prop-types';
import CustomTooltip from '@assets/components/Atoms/CustomTooltip';
import {labelSizeMapping} from '@assets/const/popupSize';
import {cleanString} from '@assets/helpers/blockXSSAttack';

const buttonDefaultSettings = {
  labelColor: '#FFFFFF',
  labelSize: '0.75em'
};

export default function LauncherLabel({
  isCustomSize,
  isLabelChanged,
  isLauncherSelected,
  settings,
  i18n,
  open
}) {
  const {floatBtnLabelColor, floatBtnLabel, floatBtnSize} = settings;
  const font = settings.headingTextFont || 'Inter';
  const fontFamily = font.replace('+', ' ');

  const labelSize = isCustomSize ? labelSizeMapping[floatBtnSize] : buttonDefaultSettings.labelSize;
  const labelColor = isLauncherSelected ? floatBtnLabelColor : buttonDefaultSettings.labelColor;
  const inputValue = (() => {
    if (!floatBtnLabel) return '';
    if (isLabelChanged) return cleanString(floatBtnLabel);
    return i18n('Launcher label');
  })();
  const overflow = inputValue.length > 20;

  return (
    <>
      <p
        style={{
          color: labelColor,
          fontSize: labelSize,
          overflow: isCustomSize ? 'unset' : 'hidden',
          textOverflow: isCustomSize ? 'unset' : 'ellipsis',
          whiteSpace: 'nowrap',
          fontFamily
        }}
      >
        {inputValue.slice(0, 20) + (overflow ? '...' : '')}
      </p>
      {overflow && <CustomTooltip title={inputValue} open={open} placement="top" />}
    </>
  );
}

LauncherLabel.propTypes = {
  isCustomSize: PropTypes.bool,
  isLabelChanged: PropTypes.bool,
  isLauncherSelected: PropTypes.bool,
  translation: PropTypes.object,
  settings: PropTypes.object,
  open: PropTypes.bool
};
